import React from "react";
import UniversitiesComponent from "../../../components/Intelligence/Universities";

export default function UniversitiesPage() {
    return <UniversitiesComponent />;
}
